// import React from "react";

// // Single Card Component
// const Card = ({ title, value, color, desc }) => (
//     <div
//         style={{
//             background: "#fff",
//             borderRadius: "16px",
//             padding: "20px",
//             textAlign: "center",
//             boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
//             flex: "1",
//             minWidth: "100px",
//             margin: "0 8px",
//         }}
//     >
//         <p style={{ fontSize: "13px", fontWeight: "600", color: "#132530" }}>
//             {title}
//         </p>

//         <div
//             style={{
//                 width: "60px",
//                 height: "60px",
//                 background: color,
//                 borderRadius: "12px",
//                 margin: "12px auto",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontWeight: "700",
//                 fontSize: "18px",
//                 color: "#fff",
//             }}
//         >
//             {value}
//         </div>

//         <p style={{ fontSize: "12px", color: "#555" }}>{desc}</p>
//     </div>
// );

// const PointsCardsSummary = ({ rewardsPointsStates, offers }) => {
//     const availablePoints = rewardsPointsStates?.availabe_points || 0;

//     const requiredPoints = offers?.length
//         ? Math.min(...offers.map(o => o.business_redeem_offer_points))
//         : 0;

//     const pointsAway =
//         requiredPoints > availablePoints ? requiredPoints - availablePoints : 0;

//     const progressPercent =
//         requiredPoints > 0
//             ? Math.min((availablePoints / requiredPoints) * 100, 100)
//             : 0;

//     const progressColor =
//         progressPercent >= 80
//             ? "#6EDC89"
//             : progressPercent >= 50
//                 ? "#FFD166"
//                 : "rgb(204, 0, 11)";

//     return (
//         <div
//             className=""
//             style={{
//                 position: "relative",
//                 minHeight: "480px",
//             }}
//         >
//             {/* Top Background Shape */}
//             <div
//                 style={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "220px",
//                     borderBottomLeftRadius: "50% 40%",
//                     borderBottomRightRadius: "50% 40%",
//                     zIndex: 0,
//                 }}
//             />

//             {/* Main Card */}
//             <div
//                 style={{
//                     width: "750px",
//                     margin: "0 auto",
//                     position: "relative",
//                     top: 0,
//                     padding: "30px 25px",
//                     borderRadius: "20px",
//                     background: "#fff",
//                     zIndex: 2,
//                     textAlign: "center",
//                 }}
//             >
//                 <div className="mb-1">
//                     <span
//                         style={{
//                             background: "#cc000b",
//                             color: "#fff",
//                             padding: "6px 14px",
//                             borderRadius: "20px",
//                             fontSize: "12px",
//                         }}
//                     >
//                         Progress Points
//                     </span>
//                 </div>

//                 <h2 className="mb-0">Redeem Your Points</h2>

//                 <p style={{ fontSize: "13px" }}>
//                     Monitor your rewards progress
//                 </p>

//                 {/* Progress Bar */}
//                 <div style={{ maxWidth: "420px", margin: "0 auto 20px" }}>
//                     <p
//                         style={{
//                             textAlign: "center",
//                             marginBottom: "6px",
//                             fontWeight: "600",
//                         }}
//                     >
//                         {Math.round(progressPercent)}% toward your next reward
//                     </p>

//                     <div
//                         style={{
//                             position: "relative",
//                             height: "14px",
//                             background: "#132530",
//                             borderRadius: "20px",
//                             overflow: "hidden",
//                         }}
//                     >
//                         <div
//                             style={{
//                                 width: `${progressPercent}%`,
//                                 height: "100%",
//                                 background: progressColor,
//                                 transition: "width 0.6s ease",
//                                 borderRadius: "20px",
//                             }}
//                         />

//                         {/* Marker */}
//                         <div
//                             style={{
//                                 position: "absolute",
//                                 left: `${progressPercent}%`,
//                                 top: "-3px",
//                                 width: "20px",
//                                 height: "20px",
//                                 background: "#fff",
//                                 border: "2px solid #cc000b",
//                                 borderRadius: "50%",
//                                 transform: "translateX(-50%)",
//                             }}
//                         />
//                     </div>

//                     <p
//                         style={{
//                             textAlign: "center",
//                             fontSize: "13px",
//                             marginTop: "8px",
//                         }}
//                     >
//                         {pointsAway > 0
//                             ? `You're ${pointsAway} points away from your next reward!`
//                             : "🎉 You can redeem rewards now!"}
//                     </p>
//                 </div>

//                 {/* Cards */}
//                 <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
//                     <Card
//                         title="Available reward points"
//                         value={availablePoints}
//                         color="#28a745"
//                         desc={
//                             pointsAway > 0
//                                 ? `You're ${pointsAway} points away from your next reward!`
//                                 : "Ready to redeem!"
//                         }
//                     />
//                     <Card
//                         title="Expiring Reward Points"
//                         value={rewardsPointsStates?.next_year_expiry || 0}
//                         color="#cc000b"
//                         desc="Expiring soon – redeem now"
//                     />
//                     <Card
//                         title="Redeemed reward points"
//                         value={rewardsPointsStates?.last_month_redeem || 0}
//                         color="#132530"
//                         desc="Redeemed this month"
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PointsCardsSummary;

import React from "react";

// Single Card Component
const Card = ({ title, value, color, desc }) => (
    <div
        style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "20px",
            textAlign: "center",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            flex: "1",
            minWidth: "100px",
            margin: "0 8px",
        }}
    >
        <p
            style={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#132530",
                marginBottom: "8px",
            }}
        >
            {title}
        </p>

        <div
            style={{
                width: "60px",
                height: "60px",
                background: color,
                borderRadius: "12px",
                margin: "12px auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "18px",
                color: "#fff",
            }}
        >
            {value}
        </div>

        <p
            style={{
                fontSize: "12px",
                color: "#555",
                marginBottom: 0,
            }}
        >
            {desc}
        </p>
    </div>
);

const PointsCardsSummary = ({ rewardsPointsStates, offers }) => {
    const availablePoints = Number(
        rewardsPointsStates?.availabe_points || 0
    );

    const expiringPoints = Number(
        rewardsPointsStates?.next_year_expiry?.business_reward_points || 0
    );

    const redeemedPoints = Number(
        rewardsPointsStates?.last_month_redeem?.business_reward_points || 0
    );

    const requiredPoints = offers?.length
        ? Math.min(
            ...offers.map((offer) =>
                Number(offer?.business_redeem_offer_points || 0)
            )
        )
        : 0;

    const pointsAway =
        requiredPoints > availablePoints
            ? requiredPoints - availablePoints
            : 0;

    const progressPercent =
        requiredPoints > 0
            ? Math.min((availablePoints / requiredPoints) * 100, 100)
            : 0;

    const progressColor =
        progressPercent >= 80
            ? "#6EDC89"
            : progressPercent >= 50
                ? "#FFD166"
                : "rgb(204, 0, 11)";

    return (
        <div
            style={{
                position: "relative",
                minHeight: "350px",
            }}
        >
            {/* Top Background Shape */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "220px",
                    borderBottomLeftRadius: "50% 40%",
                    borderBottomRightRadius: "50% 40%",
                    zIndex: 0,
                }}
            />

            {/* Main Card */}
            <div
                style={{
                    width: "750px",
                    maxWidth: "100%",
                    margin: "0 auto",
                    position: "relative",
                    top: 0,
                    padding: "30px 25px",
                    borderRadius: "20px",
                    background: "#fff",
                    zIndex: 2,
                    textAlign: "center",
                }}
            >
                <div className="mb-1">
                    <span
                        style={{
                            background: "#cc000b",
                            color: "#fff",
                            padding: "6px 14px",
                            borderRadius: "20px",
                            fontSize: "12px",
                        }}
                    >
                        Progress Points
                    </span>
                </div>

                <h2 className="mb-0">
                    Redeem Your Points
                </h2>

                <p style={{ fontSize: "13px" }}>
                    Monitor your rewards progress
                </p>

                {/* Progress Bar */}
                <div
                    style={{
                        maxWidth: "420px",
                        margin: "0 auto 20px",
                    }}
                >
                    <p
                        style={{
                            textAlign: "center",
                            marginBottom: "6px",
                            fontWeight: "600",
                        }}
                    >
                        {Math.round(progressPercent)}% toward your next reward
                    </p>

                    <div
                        style={{
                            position: "relative",
                            height: "14px",
                            background: "#132530",
                            borderRadius: "20px",
                            overflow: "visible",
                        }}
                    >
                        <div
                            style={{
                                width: `${progressPercent}%`,
                                height: "100%",
                                background: progressColor,
                                transition: "width 0.6s ease",
                                borderRadius: "20px",
                            }}
                        />

                        {/* Marker */}
                        <div
                            style={{
                                position: "absolute",
                                left: `${progressPercent}%`,
                                top: "-3px",
                                width: "20px",
                                height: "20px",
                                background: "#fff",
                                border: "2px solid #cc000b",
                                borderRadius: "50%",
                                transform: "translateX(-50%)",
                            }}
                        />
                    </div>

                    <p
                        style={{
                            textAlign: "center",
                            fontSize: "13px",
                            marginTop: "8px",
                            marginBottom: 0,
                        }}
                    >
                        {pointsAway > 0
                            ? `You're ${pointsAway} points away from your next reward!`
                            : "🎉 You can redeem rewards now!"}
                    </p>
                </div>

                {/* Cards */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "12px",
                    }}
                >
                    <Card
                        title="Available reward points"
                        value={availablePoints}
                        color="#28a745"
                        desc={
                            pointsAway > 0
                                ? `You're ${pointsAway} points away from your next reward!`
                                : "Ready to redeem!"
                        }
                    />

                    <Card
                        title="Expiring Reward Points"
                        value={expiringPoints}
                        color="#cc000b"
                        desc="Expiring soon – redeem now"
                    />

                    <Card
                        title="Redeemed reward points"
                        value={redeemedPoints}
                        color="#132530"
                        desc="Redeemed this month"
                    />
                </div>
            </div>
        </div>
    );
};

export default PointsCardsSummary;